import React from 'react';
import { ForgotPasswordForm } from './components/forgot-password-form';
import { useSelector } from 'react-redux';
import { selectSettings } from 'app/slice/selectors';
import { mediaBaseUrl } from 'utils/api/endpoints';
import { Link } from 'react-router-dom';

const ForgotPasswordPage = () => {
  const settings = useSelector(selectSettings);
  return (
    <div className="min-h-screen flex items-center justify-center px-4 py-12 bg-gray-50">
      <div className="max-w-md w-full space-y-8 bg-white dark:bg-transparent p-8 rounded-2xl">
        <div className="text-center">
          <img
            src={`${mediaBaseUrl}/site/${settings?.options?.logo}`}
            alt={settings?.site_name}
            className="max-w-[110px] mx-auto mb-4"
          />
          <h2 className="text-3xl font-bold tracking-tight text-gray-900">
            Forgot your password?
          </h2>
          <p className="mt-2 text-sm text-gray-600">
            Enter your email address and we'll send you a reset link.
          </p>
        </div>
        <ForgotPasswordForm />
        <div className="text-center mt-4">
          <Link to="/login" className="text-sm text-primary hover:underline">
            Back to login
          </Link>
        </div>
      </div>
    </div>
  );
};

export default ForgotPasswordPage;
